<div class="target-resource-list-item l_flexbar guts-p-v-1">
  <div [ngSwitch]="item.referenceType">
    <div *ngSwitchCase="'User'">
      <dgx-profile-pic
        [profile]="item"
        size="small"
        class="guts-m-h-1"
      ></dgx-profile-pic>
    </div>

    <div *ngSwitchCase="'Provider'">
      <img
        class="provider__flex-search-image guts-m-h-1"
        [alt]="item.title"
        [src]="item.providerImageUrl"
      />
    </div>

    <div *ngSwitchCase="'Tag'">
      <div class="icon-spot bg-color-ebony-a08-hue center-item guts-m-h-1">
        <df-icon
          [icon]="item.referenceType.toLowerCase()"
          class="color-ebony-a61"
        ></df-icon>
      </div>
    </div>

    <div *ngSwitchCase="'Group'">
      <div class="icon-spot bg-color-ebony-a08-hue center-item guts-m-h-1">
        <df-icon icon="person-double" class="color-ebony-a61"></df-icon>
      </div>
    </div>

    <div *ngSwitchCase="'Target'">
      <div class="icon-spot bg-color-ebony-a08-hue center-item guts-m-h-1">
        <df-icon icon="page" class="color-ebony-a61"></df-icon>
      </div>
    </div>
    <ng-container *ngSwitchCase="'Pathway'"></ng-container>

    <div *ngSwitchDefault class="guts-m-h-1">
      <dgx-image-layout
        format="list"
        [imageSrc]="item.image"
        [videoUrl]="item.referenceType === 'Video' ? item.url : ''"
        [providerImage]="item.providerImageInfo?.svg"
      >
      </dgx-image-layout>
    </div>
  </div>

  <div>
    <h3 class="par par--small font-bold">
      {{ item.title }}
      <img
        class="tag-endorsed-img v-bottom"
        *ngIf="item.endorsedSrc"
        [src]="item.endorsedSrc + '?brandlogo'"
        [alt]="i18n.Core_Endorsed"
      />
    </h3>
    <p
      *ngIf="item.details"
      class="par par--small par--light guts-p-full-0"
      [textContent]="item.details"
    ></p>
    <p class="par par--small par--light guts-m-r-half">
      <span>{{ item.displayType }}</span>
      <df-icon
        *ngIf="isRestrictedContent"
        icon="alert"
        [ngbTooltip]="i18n.OrgInternalContent_RestrictedContentNote"
        triggers="focus mouseenter"
        [openDelay]="1000"
        placement="auto top"
        class="color-ebony-a61"
      ></df-icon>
    </p>
  </div>
</div>
